import '../css/styles.scss'
import { ua } from './modules/ua'
import { klass, scrollSmooth } from './modules/common'
import Swiper from 'swiper/bundle'

class App {
  constructor() {
    this.body = document.querySelector('body')
    this.init()
  }

  init() {
    // 全ページ共通適用
    this.body.classList.add(`is-${ua.browser()}`)
    this.body.classList.add(`is-${ua.os()}`)
    this.pageCommonSetting()
    window.addEventListener('resize', () => {})
    window.addEventListener('scroll', () => {})
  }

  pageCommonSetting() {
    // スムーススクロール
    const smoothScrollTarget = Array.from(document.querySelectorAll('.js-smooth-scroll'))
    if (smoothScrollTarget.length > 0) {
      smoothScrollTarget.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          const targetId = e.target.hash
          document.querySelector('body').classList.remove('view-nav')

          if (!document.querySelector(targetId)) {
            return false
          }
          scrollSmooth(targetId)
        })
      })
    }

    const goodsImgs = Array.from(document.querySelectorAll('.goods__list-item__imgs'))
    const goodsSlide = []
    if (goodsImgs) {
      goodsImgs.forEach((img, i) => {
        if (img.getAttribute('data-slide')) {
          goodsSlide[i] = new Swiper(`[data-slide="${img.getAttribute('data-slide')}"]  `, {
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
            },
          })
        }
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.asnova = new App()
})

window.addEventListener('load', () => {
  document.querySelector('body').classList.add('is-loaded')
})
